<template>
    <tbody v-if="time_info">
        <tr>
            <td colspan="2"><h2>Time and Zone</h2></td>
        </tr>
        <tr v-for="info in time_info">
            <td :data-export-label="info.label">{{ info.label }}:</td>

            <td> {{ info.value }} </td>
        </tr>
    </tbody>
</template>
<script>
export default {
    name: 'TimeInfo',

    props: ['time_info']
};
</script>
